// vendor
import { Ref, ref } from "@vue/composition-api";
// project
import * as AssetAPI from "@/services/api/assets";
import { AssetVersion } from "@/psychlab/types/assets";
import { Dictionary } from "@/utils/types";

let loaded = false;

let _versions:Ref<Dictionary<AssetVersion<any>[]>>;

let _requests:Dictionary<Promise<AssetVersion<any>[]>> = {};

const init = async () => {
	
	_versions = ref<Dictionary<AssetVersion<any>[]>>({});
};

export const useVersionCache = () => {

	if(!loaded){
		init();
		loaded = true;
	}

	const getVersionList = async(assetId:string):Promise<AssetVersion<any>[]> => {
		if(_versions.value[assetId]){
			return _versions.value[assetId];
		}

		if(!_requests[assetId]){
			_requests[assetId] = AssetAPI.loadVersionList(assetId);
			_versions.value[assetId] = await _requests[assetId];
			delete _requests[assetId];
			return _versions.value[assetId];
		}
		else {
			return await _requests[assetId];
		}
	};
	
	return {
		getVersionList
	};

};